import { useState, useEffect } from 'react';
import RoundedDialog from '../../../../../Global/Components/RoundedDialog';
import { DialogTitle, DialogContent, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { StandardDialogActions } from '../../../../../Global/Components';

export default function ImageSizeDialog({ open, onClose, size, onChange }) {
  const [imageSize, setImageSize] = useState();
  useEffect(() => {
    setImageSize(size || 'contained');
  }, [size]);

  function handleChange(e, newVal) {
    setImageSize(newVal);
    onChange(newVal);
  }

  return (
    <RoundedDialog open={open}>
      <DialogTitle title="Image Size">{'Change image size'}</DialogTitle>
      <DialogContent>
        <ToggleButtonGroup value={imageSize} exclusive onChange={handleChange}>
          <ToggleButton value="contain">{'Contained'}</ToggleButton>
          <ToggleButton value="cover">{'Full-Sized'}</ToggleButton>
        </ToggleButtonGroup>
      </DialogContent>
      <StandardDialogActions onClose={onClose}></StandardDialogActions>
    </RoundedDialog>
  );
}
